import { Skeleton } from '@mv/web-ui';
import styles from './SidepanelSkeleton.module.scss';

export function SidepanelHeaderSkeleton() {
	return (
		<div className={styles.header}>
			<Skeleton width="85%" height="28px" />
			<Skeleton width="60%" height="28px" />
		</div>
	);
}

export function SidepanelContentSkeleton() {
	return (
		<div className={styles.content}>
			<div className={styles.section}>
				<Skeleton width="65%" height="15px" />
				<Skeleton width="100%" height="12px" />
				<Skeleton width="88%" height="12px" />
			</div>
			<div className={styles.section}>
				<Skeleton width="48%" height="15px" />
				<Skeleton width="100%" height="12px" />
				<Skeleton width="92%" height="12px" />
				<Skeleton width="80%" height="12px" />
			</div>
			<div className={styles.section}>
				<Skeleton width="52%" height="15px" />
				<div className={styles.indent}>
					{(['78%', '85%', '72%'] as const).map((w) => (
						<div key={w} className={styles.indentItem}>
							<Skeleton width="8px" height="8px" />
							<Skeleton width={w} height="12px" />
						</div>
					))}
				</div>
			</div>
			<div className={styles.section}>
				<Skeleton width="58%" height="15px" />
				<div className={styles.indent}>
					{(['82%', '70%', '88%'] as const).map((w) => (
						<div key={w} className={styles.indentItem}>
							<Skeleton width="8px" height="8px" />
							<Skeleton width={w} height="12px" />
						</div>
					))}
				</div>
			</div>
			<div className={styles.section}>
				<Skeleton width="44%" height="15px" />
				<Skeleton width="100%" height="12px" />
				<Skeleton width="75%" height="12px" />
			</div>
		</div>
	);
}
